
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface CommonDropdownItemsProps {
  basePath: string;
  currentPath: string;
}

const CommonDropdownItems = ({ basePath, currentPath }: CommonDropdownItemsProps) => {
  // Special handling for KPI detail pages to maintain active state
  const isKpiDetailPath = currentPath.includes('/kpi/');
  
  return (
    <div className="space-y-1">
      <DropdownLink 
        to={`/${basePath}/top-kpis`} 
        isActive={currentPath === `/${basePath}/top-kpis` || (basePath === 'energy' && isKpiDetailPath)}
      >
        Top KPIs
      </DropdownLink>
      
      <DropdownLink 
        to={`/${basePath}/analytics`} 
        isActive={currentPath === `/${basePath}/analytics`}
      >
        Analytics
      </DropdownLink>
      
      <DropdownLink 
        to={`/${basePath}/device-health`} 
        isActive={currentPath === `/${basePath}/device-health`}
      >
        Device Health
      </DropdownLink>
      
      <DropdownLink 
        to={`/${basePath}/consumers`} 
        isActive={currentPath === `/${basePath}/consumers`}
      >
        Consumers
      </DropdownLink>
      
      <DropdownLink 
        to={`/${basePath}/bills`} 
        isActive={currentPath === `/${basePath}/bills`}
      >
        Bills
      </DropdownLink>
      
      <DropdownLink 
        to={`/${basePath}/reports`} 
        isActive={currentPath === `/${basePath}/reports`}
      >
        Reports
      </DropdownLink>
    </div>
  );
};

interface DropdownLinkProps {
  to: string;
  isActive: boolean;
  children: React.ReactNode;
}

const DropdownLink = ({ to, isActive, children }: DropdownLinkProps) => {
  return (
    <Link
      to={to}
      className={cn(
        "block px-4 py-2 text-sm rounded-md",
        isActive
          ? "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
      )}
    >
      {children}
    </Link>
  );
};

export default CommonDropdownItems;
